// DEPRECATED(formsy-retirement): legacy formsy-react field. Use a Formik-based field instead.
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getAuthUserSelector } from '@sophocles/features/auth/authSelectors';

const DateBox = props => {
  const { setValue, value, passValue, helpText, title, errorMessage, showRequired } = props;

  const user = useSelector(getAuthUserSelector);
  const dateFormat = user.getIn(['options', 'date_format'], 'yyyy-MM-dd');

  // Set the initial value when the component is mounted
  useEffect(() => {
    setValue(value);
  }, [setValue, value]);

  const changeValue = useCallback(
    (event, newValue) => {
      setValue(newValue);
      if (typeof passValue === 'function') {
        passValue(newValue);
      }
    },
    [setValue, passValue],
  );

  // Trim unnecessary props
  const trimmedProps = _.pick(props, [
    'fullWidth',
    'minDate',
    'maxDate',
    'name',
    'max',
    'min',
    'type',
    'disabled',
    'style',
    'textFieldStyle',
  ]);

  let errorText = '';
  if (errorMessage) {
    errorText = errorMessage;
  } else if (showRequired) {
    errorText = 'This Field is Required';
  }

  return (
    <DatePicker
      label={title}
      onChange={changeValue}
      value={value}
      format={dateFormat}
      {...trimmedProps}
      slotProps={{ textField: { helperText: errorText, error: !!errorText } }}
    />
  );
};

export default withFormsy(DateBox);
